__turbopack_context__.v({
  "codeField": "OtpCodeInput-module-scss-module__7MmyDW__codeField",
  "error": "OtpCodeInput-module-scss-module__7MmyDW__error",
  "field": "OtpCodeInput-module-scss-module__7MmyDW__field",
  "hint": "OtpCodeInput-module-scss-module__7MmyDW__hint",
  "label": "OtpCodeInput-module-scss-module__7MmyDW__label",
  "slot": "OtpCodeInput-module-scss-module__7MmyDW__slot",
  "slots": "OtpCodeInput-module-scss-module__7MmyDW__slots",
});
